import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	OnDestroy,
	OnInit,
	ViewChild,
	ViewEncapsulation,
} from "@angular/core";
import { DialogLayoutComponent } from "@obg/mat.ui.core";
import { DepositLimitRequiredService } from "@obg/ngx.core";
import { Subscription } from "rxjs";
import { filter, tap } from "rxjs/operators";

@Component({
	selector: "obg-m-multi-deposit-limit-dialog",
	styleUrls: ["./multi-deposit-limit-dialog.container.scss"],
	templateUrl: "./multi-deposit-limit-dialog.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class MultiDepositLimitDialogContainer implements OnInit, OnDestroy {
	@HostBinding("class.obg-m-multi-deposit-limit-dialog") hostCssClass = true;
	@ViewChild("dialog") dialogLayout!: DialogLayoutComponent;

	private data$$: Subscription | undefined;

	constructor(private depositLimitRequiredService: DepositLimitRequiredService) {}

	ngOnInit() {
		this.data$$ = this.depositLimitRequiredService
			.isDepositLimitUnset$()
			.pipe(
				filter((isUnset) => !isUnset),
				tap(() => this.dialogLayout.close())
			)
			.subscribe();
	}

	onNavigate() {
		this.dialogLayout.close();
	}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}
}
